import { toast } from 'sonner'
import i18n from '../i18n'

export async function copyToClipboard(text: string): Promise<void> {
  await navigator.clipboard.writeText(text)
  toast.success(i18n.t('common.copiedToClipboard'))
}
